<template>
<v-layout justify-space-around wrap row>
    <v-flex xs12 sm4 scrollDesign style="max-height: 55vh;">
      <v-slide-x-transition mode="out-in">
        <v-list subheader two-line>
          <v-subheader key="subheader">Tutores</v-subheader>
          <draggable :list="list" group="elements" class="list-group" draggable=".item">
            <v-slide-y-transition class="two-line subheader" group>
              <v-list-tile
				avatar
				class="pa-2 mb-3 elevation-1 grey lighten-5 list-group-item item"
				style="border-radius: 5px;"
				v-for="element in list"
				:key="element.id">

					<v-list-tile-avatar>
						<v-img :src="require('@/assets/panel/home/SKLB-Tutores.png')"></v-img>
					</v-list-tile-avatar>

					<v-list-tile-content>
						<v-list-tile-title v-text="element.firstName + ' ' + element.lastName"/>
            <v-list-tile-sub-title v-text="element.mail"/>

					</v-list-tile-content>

				</v-list-tile>

              	<v-list-tile
				avatar
				class="pa-2 mb-3 list-group-item item"
				style="border-radius: 5px;"
				:key="0"
				>
					<v-list-tile-avatar>
						<v-icon color="primary" large>add</v-icon>
					</v-list-tile-avatar>

					<v-list-tile-content>
						<v-list-tile-title>Arrastrar Tutores</v-list-tile-title>
					</v-list-tile-content>

				</v-list-tile>
							
              <v-list-tile
                avatar
                class="pa-2 mb-3 list-group-item item"
                style="border-radius: 5px;"
                color="primary" 
                :key="-1"
              >
                <v-list-tile-content right>
                  <v-list-tile-content>
                    <v-btn flat color="primary" small @click="viewMore" v-if="showBtnScroll && list.length > 0">Buscar más</v-btn>
                    <v-list-tile-title style="font-size: 12px; color: rgba(0,0,0,.54);" v-if="!showBtnScroll && list.length > 0">Todos los resultados fueron mostrados</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile-content>
              </v-list-tile>
            </v-slide-y-transition>
          </draggable>
        </v-list>
      </v-slide-x-transition>
    </v-flex>
    <v-flex xs6>
      <v-list subheader>
        <v-subheader key="subheader">Tutores Agregados</v-subheader>

        <draggable group="elements" class="list-group" :list="selectedList" draggable=".item">
          <v-slide-y-transition class="two-line subheader" group>
            <v-list-tile
              avatar
              class="pa-2 mb-3 elevation-1 grey lighten-5 list-group-item item"
              style="border-radius: 5px;"
              v-for="element in selectedList"
              :key="element.id"
            >
             	<v-list-tile-avatar>
					<v-img :src="require('@/assets/panel/home/SKLB-Tutores.png')"></v-img>
				</v-list-tile-avatar>

              <v-list-tile-content>
				        <v-list-tile-title v-text="element.firstName + ' ' + element.lastName"/>
                 <v-list-tile-sub-title v-text="element.mail"/>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              avatar
              class="pa-2 mb-3 list-group-item item"
              style="border-radius: 5px;"
              :key="0"
            >
              <v-list-tile-avatar>
                <v-icon color="primary" large>add</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>Arrastrar Tutores</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-slide-y-transition>
        </draggable>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
	import draggable from "vuedraggable";
	export default {
		components: {
			draggable
		},
		props: ["value", "array", "showBtnScroll"],
		watch: {
			array() {
				this.list = this.array;
			},
			value() {
				this.selectedList = this.value;
			},
			selectedList() {
				this.$emit("input", this.selectedList);
      }
		},
		mounted() {
      this.list = this.array;
      this.selectedList = this.value;
			this.$forceUpdate();
		},
		methods: {
			viewMore(){
				this.$emit("viewMore");
			}
		},
		data: () => ({
			list: [],
      selectedList: []
		})
	};
</script>

<style>
</style>
